import React from 'react'
import { Button, Icon } from 'components'
import ClassName from 'classnames'
import isIos from 'utils/isIos'
import styles from './Arrow.module.scss'

const Arrow = ({ onClick, arrowDirection }) => (
  <Button
    type="text"
    onClick={onClick}
    className={ClassName(styles[`${arrowDirection}Button`], styles.arrow)}
  >
    <Icon
      type="arrow"
      size={60}
      color="whiteColor"
      className={
        styles[isIos() ? `${arrowDirection}IconIOS` : `${arrowDirection}Icon`]
      }
    />
  </Button>
)

export default Arrow
